function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m367.835938 288.960938h8c33.539062.003906 64.164062-19.058594 78.96875-49.15625 14.804687-30.09375 11.214843-65.988282-9.253907-92.554688-20.472656-26.570312-54.265625-39.191406-87.140625-32.546875-4.324218-21.582031-18.304687-39.992187-37.933594-49.957031-19.625-9.964844-42.738281-10.382813-62.714843-1.136719-18.078125-49.796875-73.101563-75.507813-122.898438-57.429687-49.796875 18.082031-75.507812 73.105468-57.429687 122.902343-43.621094 1.375-78.078125 37.480469-77.4257815 81.117188.6562495 43.640625 36.1835935 78.691406 79.8281255 78.761719",
  fill: "#a3d4f7"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "#92aeba"
}, /*#__PURE__*/React.createElement("path", {
  d: "m319.835938 320.960938h-80c-4.421876 0-8-3.582032-8-8 0-4.417969 3.578124-8 8-8h80c4.417968 0 8 3.582031 8 8 0 4.417968-3.582032 8-8 8zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m159.835938 320.960938h-64c-4.421876 0-8-3.582032-8-8 0-4.417969 3.578124-8 8-8h64c4.417968 0 8 3.582031 8 8 0 4.417968-3.582032 8-8 8zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m207.835938 320.960938h-16c-4.421876 0-8-3.582032-8-8 0-4.417969 3.578124-8 8-8h16c4.417968 0 8 3.582031 8 8 0 4.417968-3.582032 8-8 8zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m223.835938 368.960938h-96c-4.421876 0-8-3.582032-8-8 0-4.417969 3.578124-8 8-8h96c4.417968 0 8 3.582031 8 8 0 4.417968-3.582032 8-8 8zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m351.835938 368.960938h-32c-4.421876 0-8-3.582032-8-8 0-4.417969 3.578124-8 8-8h32c4.417968 0 8 3.582031 8 8 0 4.417968-3.582032 8-8 8zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m287.835938 368.960938h-32c-4.421876 0-8-3.582032-8-8 0-4.417969 3.578124-8 8-8h32c4.417968 0 8 3.582031 8 8 0 4.417968-3.582032 8-8 8zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m319.835938 224.960938h-80c-4.421876 0-8-3.582032-8-8 0-4.417969 3.578124-8 8-8h80c4.417968 0 8 3.582031 8 8 0 4.417968-3.582032 8-8 8zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m159.835938 224.960938h-64c-4.421876 0-8-3.582032-8-8 0-4.417969 3.578124-8 8-8h64c4.417968 0 8 3.582031 8 8 0 4.417968-3.582032 8-8 8zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m207.835938 224.960938h-16c-4.421876 0-8-3.582032-8-8 0-4.417969 3.578124-8 8-8h16c4.417968 0 8 3.582031 8 8 0 4.417968-3.582032 8-8 8zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m223.835938 272.960938h-96c-4.421876 0-8-3.582032-8-8 0-4.417969 3.578124-8 8-8h96c4.417968 0 8 3.582031 8 8 0 4.417968-3.582032 8-8 8zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m351.835938 272.960938h-32c-4.421876 0-8-3.582032-8-8 0-4.417969 3.578124-8 8-8h32c4.417968 0 8 3.582031 8 8 0 4.417968-3.582032 8-8 8zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m287.835938 272.960938h-32c-4.421876 0-8-3.582032-8-8 0-4.417969 3.578124-8 8-8h32c4.417968 0 8 3.582031 8 8 0 4.417968-3.582032 8-8 8zm0 0"
}));

var SvgFog = function SvgFog(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "463pt",
    viewBox: "0 -47 463.84305 463",
    width: "463pt",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFog, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fog.7850bef1.svg";
export { ForwardRef as ReactComponent };